import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TableRowItem } from '@components/components/table/table.interface';

@Component({
  selector: 'sp-table-body-row',
  standalone: false,
  templateUrl: './table-body-row.component.html',
  styleUrls: ['./table-body-row.component.scss']

})
export class TableBodyRowComponent implements TableRowItem {
  @Input() DataService = {
    create: formGroup => {},
    fetch: () => {},
    update: (id, formGroup) => {},
    delete: id => {}
  };
  @Input() id = null;
  @Input() title = '';
  @Input() form = null;
  @Input() sendData = null;
  @Input() activeFormFieldIndex = null;
  @Input() cells = null;
  @Input() buttons = null;
  @Input() expandableTable = null;
  @Input() expanded = null;
  @Input() extendedRow = null;
  @Input() extended = null;
  @Input() formGroup = new UntypedFormGroup({});
  @Input() query = null;
  @Input() basicQuery = null;
  @Input() selected: boolean;
  @Input() withCheckbox: boolean;
  @Input() disabled: boolean;
  @Input() highlight: boolean;
  @Input() rowsCheck: boolean; // used for directive tables
  @Output() propagateChecked = new EventEmitter<boolean>();
  @Input() cancelTableForm: any = null;
  @Input() submitTableForm = () => {};

  constructor() {}

  expandRow(row: TableRowItem) {
    row.expanded = !row.expanded;
  }

  onToggleRowCheckox(event) {
    const check = event.target.checked;
    this.propagateChecked.emit(check);
  }
}